import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { images } from '../../data/images';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
const roles = ['CEO', 'CFO', 'COO', 'CTO', 'CHRO', 'General Counsel', 'Chair', 'NED'];
export function ExecutiveFeature() {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-30, 30]);
  return <section className="overflow-hidden bg-midnight py-24 text-white md:py-32" data-id="element-157" data-mp="vx8yrdt9x0re">
      <div className="container-page grid items-center gap-14 lg:grid-cols-12" data-id="element-158" data-mp="qye2pa6apfpc">
        <div ref={ref} className="relative lg:col-span-6" data-id="element-159" data-mp="m0w4adpwmivl">
          <div className="relative aspect-[4/3] overflow-hidden rounded-xl" data-id="element-160" data-mp="hzak07b1j2bd">
            <motion.img src={images.leadersMeeting} alt="Two senior executives in a private conversation in a wood-panelled office" loading="lazy" style={{
            y,
            scale: 1.12
          }} className="h-full w-full object-cover" data-id="element-161" data-mp="2v5tvng3nzj7s" />
          </div>
          <div className="absolute -bottom-6 left-6 flex items-center gap-3 rounded-lg border border-white/10 bg-midnight-800 px-5 py-4 shadow-lift md:left-auto md:right-8" data-id="element-162" data-mp="2q6h9kxkmag69">
            <LockIcon className="h-5 w-5 text-gold-300" aria-hidden="true" data-id="element-163" data-mp="3duidft6up8fc" />
            <p className="text-sm text-white/85" data-id="element-164" data-mp="3iuwe2q64hg3c">Confidential, code-named searches available</p>
          </div>
        </div>
        <div className="lg:col-span-6 lg:pl-6" data-id="element-165" data-mp="34xzlaj6g1ojt">
          <SectionHeading tone="dark" kicker="Executive Search" title="Leadership appointments, handled with judgement and discretion." intro="We map the market, approach leaders directly and assess them against the outcomes your organisation needs — so your shortlist reflects the best available talent, not just the visible." data-id="element-166" data-mp="38w75jo0497zr" />
          <ul className="mt-8 flex flex-wrap gap-2" aria-label="Typical appointments" data-id="element-167" data-mp="3v5dtr6knwk1c">
            {roles.map(r => <li key={r} className="rounded border border-white/15 px-3 py-1.5 text-sm text-white/85" data-id="element-168" data-mp="3qdmc5ljhhonc">
                {r}
              </li>)}
          </ul>
          <div className="mt-10 flex flex-wrap gap-3" data-id="element-169" data-mp="3hesctnerqk63">
            <Button to="/executive-search" size="lg" arrow data-id="element-170" data-mp="3hc643kg55yma">
              Begin a Confidential Search
            </Button>
            <Button to="/process" size="lg" variant="outlineLight" data-id="element-171" data-mp="37g2yu5pztjv4">
              Our search process
            </Button>
          </div>
        </div>
      </div>
    </section>;
}